import type { HighlightState } from "./highlightState";
import { FLOOR_HEIGHT } from "../constants/camera";

// Парсит этаж из названия лестницы: stairs_1_2_1 → 1
function getStairsFloorFromName(stairsId: string): number | null {
  const match = stairsId.match(/^stairs_(\d+)/i);
  return match ? parseInt(match[1], 10) : null;
}

export interface FloorVisibility {
  visibleFloors: Set<number>;
  dimmedFloors: Set<number>;
  hiddenFloors: Set<number>;
  visibleStairs: Set<string>;
  dimmedStairs: Set<string>;
  mode: "none" | "full_route" | "segment" | "floor_selected";
}

export function computeFloorVisibility(
  state: HighlightState,
  allFloors: number[] = [1, 2, 3, 4, 5, 6],
): FloorVisibility {
  const visible = new Set<number>();
  const dimmed = new Set<number>();
  const hidden = new Set<number>();
  const visibleStairs = new Set<string>();
  const dimmedStairs = new Set<string>();

  switch (state.type) {
    case "none": {
      // Выбранный и ниже - видимы, выше - скрыты
      for (const f of allFloors) {
        if (f <= state.currentFloor) visible.add(f);
        else hidden.add(f);
      }
      // Лестницы будут определяться по этажу в building.tsx
      break;
    }
    case "full_route": {
      // Этажи маршрута видимы, остальные скрыты
      for (const f of allFloors) {
        if (state.floors.has(f)) visible.add(f);
        else hidden.add(f);
      }
      // Все лестницы маршрута видны
      state.stairs.forEach((s) => visibleStairs.add(s));
      break;
    }
    case "segment": {
      // Этаж сегмента видим, этажи маршрута затемнены, остальные скрыты
      for (const f of allFloors) {
        if (f === state.floor) visible.add(f);
        else if (state.routeFloors.has(f)) dimmed.add(f);
        else hidden.add(f);
      }
      // Лестницы сегмента видны, остальные лестницы маршрута dimmed
      state.stairs.forEach((s) => visibleStairs.add(s));
      state.routeStairs.forEach((s) => {
        if (!visibleStairs.has(s)) dimmedStairs.add(s);
      });
      break;
    }
    case "floor_selected": {
      // Выбранный этаж видим, этажи маршрута затемнены, остальные скрыты
      for (const f of allFloors) {
        if (f === state.selectedFloor) visible.add(f);
        else if (state.routeFloors.has(f)) dimmed.add(f);
        else hidden.add(f);
      }
      // Лестницы маршрута: принадлежащие этажу → visible, остальные → dimmed
      state.routeStairs.forEach((s) => {
        const stairsFloor = getStairsFloorFromName(s);
        if (stairsFloor === state.selectedFloor) {
          visibleStairs.add(s);
        } else {
          dimmedStairs.add(s);
        }
      });
      break;
    }
  }

  return {
    visibleFloors: visible,
    dimmedFloors: dimmed,
    hiddenFloors: hidden,
    visibleStairs,
    dimmedStairs,
    mode: state.type,
  };
}

export function getFloorFromY(y: number): number {
  return Math.floor(y / FLOOR_HEIGHT) + 1;
}
